export default function getUser(state) {
    return state.userState;
}
